
import React, { Component } from 'react'
import { Form, Button, FormInstance, Input } from 'antd'

interface FormProps {
    onSearch: (values: any) => void
    onReset: () => void
}

class SearchForm extends Component<FormProps> {

    formRelf;
    constructor(props) {
        super(props);
        this.formRelf = React.createRef<FormInstance>();
    }

    onSearch = (values) => {
        const { onSearch } = this.props;
        console.log(values);
        onSearch(values);
    }

    onReset = () => {
        this.formRelf.current!.resetFields();
        this.props.onReset();
    }

    render () {
        
        return (
            <Form
                ref={this.formRelf}
                className="searchScanReport-form"
                onFinish={this.onSearch}
                >
                <div>
                    <Form.Item label="设备序列号" name="serialNumber">
                        <Input className="input-serialNumber" />
                    </Form.Item>
                </div>
                <div className="searchItem">
                    <Form.Item label="扫描ID" name="examinationReportId">
                        <Input />
                    </Form.Item>
                    <Form.Item label="用户名称" name="nickname">
                        <Input />
                    </Form.Item>
                    <Form.Item label="客户联系方式" name="mobileNumber">
                        <Input />
                    </Form.Item>
                    <div>
                        <Button 
                            type="primary"
                            htmlType="submit"
                            className="margin-right-20"
                            >搜索</Button>
                        <Button onClick={this.onReset}>重置</Button>
                    </div>
                </div>
                
            </Form>
        )
    }
}

export default SearchForm